import React from "react";
import "./downloadModal.scss";
import Modal from "../../atoms/modal-pay/modal-pay";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

interface DownloadModalInterface {
  isOpen: boolean;
  setIsOpen: any;
  data?: any;
}

const DownloadModal = (props: DownloadModalInterface) => {
  const { isOpen, setIsOpen, data } = props;
  //const date = new Date();
  //const año = date.getFullYear();

  return (
    <Modal open={isOpen} onClose={() => {}} className={"m-modal-download"}>
      <div className={`m-modal-download__container`}>
        <div className="m-modal-download__container__header">
          <div className="m-modal-download__container__header__close">
            <button className="icon-close" onClick={() => setIsOpen(false)} />
          </div>
        </div>
        <div className="m-modal-download__container__body">
          <div className="m-modal-download__container__body__group">
            <h3>{data?.nombreTab}</h3>
          </div>
          <div className="m-modal-join__container__body__sub-title">
            <h4>{data?.redireccionTab}</h4>
          </div>
          <div className="m-modal-download__container__body__aux-txt">
            <p>{data?.autorLibro}</p>
          </div>
          <div className="m-modal-download__container__body__steps">
            <div className="m-modal-download__container__body__steps__step-1">
              <div className="m-modal-download__container__body__steps__step-1__circle">
                <span>1</span>
              </div>
              <div className="m-modal-download__container__body__steps__step-1__txt">
                {
                  documentToReactComponents(JSON.parse(data?.descripcion?.raw))
                  /*
                <p>
                  <a
                    href={
                      data?.descripcion?.raw?.content[0]?.content[1]?.data.uri
                    }
                    download
                  >
                    Descarga
                  </a>{" "}
                  el formato de convenios
                </p>
                  */
                }
              </div>
            </div>
            <div className="m-modal-download__container__body__steps__step-2">
              <div className="m-modal-download__container__body__steps__step-2__circle">
                <span>2</span>
              </div>
              <div className="m-modal-download__container__body__steps__step-2__txt">
                {
                  /*
                  documentToReactComponents(data.descripcion.raw.content[1]) // to be tested with mailto:informacion@comfama.com.co"
                  */

                  <p>
                    Una vez diligenciado el formato, debes guardarlo en PDF y
                    enviarlo al correo
                    <a
                      href={`mailto:${
                        JSON.parse(data?.descripcion?.raw)?.content[1]
                          ?.content[3]?.content[0]?.value
                      }`}
                    >
                      {" "}
                      informacion@comfama.com.co
                    </a>{" "}
                    con el asunto: Activación convenio empresarial.
                  </p>
                }
              </div>
            </div>

            <div className="m-modal-download__container__body__steps__step-3">
              <div className="m-modal-download__container__body__steps__step-3__circle">
                <span>3</span>
              </div>
              <div className="m-modal-download__container__body__steps__step-3__txt">
                {
                  documentToReactComponents(
                    JSON.parse(data.descripcion?.raw)?.content?.[2]
                  )
                  /*<p>
                    <a href={""}>Descarga</a> el formato de las tarifas vigentes
                    para el {año}
                  </p>*/
                }
              </div>
            </div>
            <div className="m-modal-download__container__body__steps__step-3">
              <div className="m-modal-download__container__body__steps__step-3__circle">
                <span>4</span>
              </div>
              <div className="m-modal-download__container__body__steps__step-3__txt">
                {documentToReactComponents(
                  JSON.parse(data.descripcion?.raw)?.content[3]
                )}
              </div>
            </div>
            <div className="m-modal-download__container__body__steps__info">
              <p>
                {
                  JSON.parse(data?.descripcion?.raw)?.content[4]?.content[0]
                    ?.value
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DownloadModal;
